/**
 * Created by zhj on 3/15/2016.
 */
'use strict';

angular.module('telephone')
  .controller('TelephoneEditCtrl', function ($scope, $stateParams, editorModel, $state, toastService, errorHandlingService, telephoneService) {

    $scope.telephondeResourceAcl = null;

    $scope.telephoneNumber = $stateParams.telephoneNumber;
    var telpehoneResourceAclRight = function () {
      return telephoneService.getTelephoneAclRight().then(function (telephondeAclRights) {
        $scope.telephondeResourceAcl = telephondeAclRights;
        if ($scope.telephondeResourceAcl.aclRightLvel > 0) {
        }
      });
    };
    telpehoneResourceAclRight().then(function () {
      if ($stateParams.name) {
        $scope.name = $stateParams.name;
        $scope.telephoneDetail = $stateParams;
      } else {
        editorModel.getTelephone.then(function (telephoneDetail) {
          $scope.name = telephoneDetail.name;
          $scope.telephoneDetail = telephoneDetail;
        });
      }
    });

    $scope.save = function (isSaveAndNew) {
      if ($scope.telephoneForm.$error.required) {
        var requiredName = $scope.telephoneForm.$error.required[0].$name;
        var errorAlert = {type: 'F', message: requiredName + ' is required!'};
        toastService.showErrorToast(errorAlert);
      }
      else {       
        if($state.saveEnabled !== false){
          var telephoneDetail = {
            key: $scope.telephoneDetail.key,
            name: $scope.telephoneDetail.name,
            telephoneNumber: $scope.telephoneDetail.telephoneNumber
          };
          $state.saveEnabled = false;
          editorModel.save(telephoneDetail).then(function () {
            $state.saveEnabled = true;
            toastService.showSuccessToast('Save Successfully!');
            if (isSaveAndNew) {
              $state.go('telephones.new', {}, {reload: true});
            } else {           
              $state.go('telephones.list');
            }
         
        }, function (response) {
          $state.saveEnabled = true;
          errorHandlingService.handleForCommonResponse(response);
        });
        }
        
      }
    };

    $scope.cancel = function () {
      $state.go('telephones.list');
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/telephoneEditController.js